import addIcon from "@/assets/icons/add.svg";
import arrowLeftIcon from "@/assets/icons/arrowLeft.svg";
import arrowRightIcon from "@/assets/icons/arrow-right.svg";
import cartIcon from "@/assets/icons/cart.svg";
import chevronRightIcon from "@/assets/icons/chevronRight.svg";
import closeIcon from "@/assets/icons/close.svg";
import facebookIcon from "@/assets/icons/facebook.svg";
import favIcon from "@/assets/icons/favorite.svg";
import hamIcon from "@/assets/icons/hamburger.svg";
import instagramIcon from "@/assets/icons/instagram.svg";
import searchIcon from "@/assets/icons/search.svg";
import snapchatIcon from "@/assets/icons/snapchat.svg";
import subtractIcon from "@/assets/icons/subtract.svg";
import tictokIcon from "@/assets/icons/tictok.svg";
import twitterIcon from "@/assets/icons/twitter.svg";
import userIcon from "@/assets/icons/user.svg";
import youtubeIcon from "@/assets/icons/youtube.svg";
import notFound from "@/assets/images/notFound.png";
import uaeIcon from "@/assets/icons/uae.png";
import ksaIcon from "@/assets/icons/ksa.png";
import qatarIcon from "@/assets/icons/qatar.png";
import kuwaitIcon from "@/assets/icons/kuwait.png";
import egyptIcon from "@/assets/icons/egypt.png";

export {
  addIcon,
  arrowLeftIcon,
  cartIcon,
  chevronRightIcon,
  closeIcon,
  facebookIcon,
  favIcon,
  hamIcon,
  instagramIcon,
  searchIcon,
  snapchatIcon,
  subtractIcon,
  tictokIcon,
  twitterIcon,
  userIcon,
  youtubeIcon,
  arrowRightIcon,
  notFound,
  uaeIcon,
  egyptIcon,
  ksaIcon,
  kuwaitIcon,
  qatarIcon,
};
